// hooks/useAlunoFotos.js
import { useEffect, useState } from "react";
import { findByTurmaCodigo } from "../api-aluno-foto";
import { errorMessage } from "../../../util/ConfirmAlertUtil";

export const useAlunoFotos = (turma) => {
  const [listaAF, setListaAF] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!turma) return;

    const controller = new AbortController();
    setIsLoading(true);

    findByTurmaCodigo(turma.codigo, controller.signal)
      .then((data) => {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setListaAF(data);
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") errorMessage(err.message);
      })
      .finally(() => setIsLoading(false));

    return () => {
      controller.abort();
      setListaAF([]);
    };
  }, [turma]);

  return { listaAF, isLoading };
};
